import { traverseComponents } from './formSchemaUtils';

/** Participant Travel form (guest Travel is a different form and is left alone). */
export const TRAVEL_FORM_ID = '68e781408e1384b2c283c3af';

const TRAVEL_CONTAINERS = ['arrivalFrom', 'departureFromLosAngeles', 'otherDetailsContainer'];
// Older rows keep the dates under flat keys (see dashboard/utils/dataGridPeriods.js).
const TRAVEL_FLAT_DATES = ['departureDateTime1', 'departureDateTime'];

const hasValue = (v) => {
  if (Array.isArray(v)) return v.length > 0;
  if (v && typeof v === 'object') return Object.values(v).some(hasValue);
  return Boolean(v);
};

const hasTravelData = (row) =>
  Boolean(
    row &&
      (TRAVEL_CONTAINERS.some((k) => hasValue(row[k])) ||
        TRAVEL_FLAT_DATES.some((k) => hasValue(row[k])))
  );

/**
 * Travel and Accommodation share person_data.dataGrid and pair rows by position,
 * so an Accommodation-only row shows up as a blank Travel row. Drop only the
 * trailing rows with no travel data: removing a blank row in the middle would
 * shift the positional pairing. Pass the participant's own rows (guest rows
 * already removed).
 */
export const dropTrailingBlankTravelRows = (ownRows) => {
  let end = ownRows.length;
  while (end > 0 && !hasTravelData(ownRows[end - 1])) end -= 1;
  const kept = ownRows.slice(0, end);
  if (ownRows.knownCaddies !== undefined) kept.knownCaddies = ownRows.knownCaddies;
  return kept;
};

const containsKey = (components, key) => {
  let found = false;
  traverseComponents(components, (c) => {
    if (c.key === key) found = true;
  });
  return found;
};

/**
 * The Travel form's data grid ships a default row, so a participant with no travel
 * sees an empty Arrival/Departure pair before pressing Add New. Start it empty instead.
 */
export const startTravelGridEmpty = (components) => {
  traverseComponents(components, (comp) => {
    if ((comp.type || '').toLowerCase() !== 'datagrid' || !Array.isArray(comp.components)) return;
    if (!containsKey(comp.components, 'arrivalFrom')) return;
    comp.initEmpty = true;
    comp.defaultValue = [];
  });
};
